import { atom } from 'recoil';

export const tagsState = atom({
  key: 'tagsState',
  default: [],
});
